import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        surveyGroup: '=',
        classifiers: '=',
        sites: '=',
        uibModalInstance: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'survey.Add participants' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form class="form" ng-submit="vm.applyFilter()">
                <div class="row">
                    <label class="label">{{ 'filter.Name' | translate }}</label>
                    <div class="items">
                        <input ng-model="vm.filter.name" type="text" class="form-control">
                    </div>
                </div>
                <div class="row">
                    <label class="label">{{ 'filter.Department' | translate }}</label>
                    <div class="items">
                        <select class="form-control" ng-model="vm.filter.departmentId"
                            ng-options="item.id as item.value for item in vm.departments">
                        <option value=""></option>
                    </select>
                    </div>
                </div>
                <div class="row">
                    <label class="label">{{ 'filter.Role' | translate }}</label>
                    <div class="items">
                        <select class="form-control" ng-model="vm.filter.drlRoleId"
                            ng-options="item.id as item.value for item in vm.roles">
                        <option value=""></option>
                    </select>
                    </div>
                </div>
                <div class="row">
                    <label class="label">{{ 'filter.Level' | translate }}</label>
                    <div class="items">
                        <select class="form-control" ng-model="vm.filter.levelId"
                            ng-options="item.id as item.value for item in vm.levels">
                        <option value=""></option>
                    </select>
                    </div>
                </div>
                <div class="row">
                    <label class="label">{{ 'filter.Status' | translate }}</label>
                    <div class="items">
                        <select class="form-control" ng-model="vm.filter.status">
                            <option value="{{ vm.USER_STATUS_ENUM.KEYS.ACTIVE }}">{{ vm.USER_STATUS_ENUM.LABELS.ACTIVE}}</option>
                            <option value="{{ vm.USER_STATUS_ENUM.KEYS.NOT_STARTED }}">{{ vm.USER_STATUS_ENUM.LABELS.NOT_STARTED}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <label class="label">{{ 'filter.Site' | translate }}</label>
                    <div class="items">
                        <select class="form-control" ng-model="vm.filter.siteId"
                            ng-options="item.id as item.name for item in vm.sites">
                            <option ng-if="vm.SiteService.hasAccessToAllSites(vm.sites)" value="">{{ 'general.All sites' | translate }}</option>
                        </select>
                        <a class="btn main small" ng-click="vm.applyFilter()">{{ 'general.Search' | translate }}</a>
                    </div>
                </div>
                <button type="submit" class="hidden" >{{ 'general.Search' | translate }}</button>
                <form-row error="vm.error">
                    <form-row-error></form-row-error>
                </form-row>
            </form>
            <pagination-tools list="vm.list" enable-all="true"></pagination-tools>
            <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.list.items.length && !vm.list.loading" ng-init="vm.initBulk()">
                <thead>
                    <tr>
                        <th class="w1p"><input ng-click="vm.toggleAll()" ng-model="vm.checked" type="checkbox"></th>
                        <th>{{ 'user.First name' | translate }}</th>
                        <th>{{ 'user.Last name' | translate }}</th>
                        <th>{{ 'user.Position' | translate }}</th>
                        <th>{{ 'user.Employment status' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td><input type="checkbox" ng-checked="vm.hasUser(item.id)" ng-click="$event.stopPropagation();vm.toggleUser(item.id)"></td>
                        <td>{{ item.firstName }}</td>
                        <td>{{ item.lastName }}</td>
                        <td>
                            <p ng-repeat="drl in item.drlsWithValue">
                                {{ drl.departmentName }}, {{ drl.roleName }}, {{ drl.levelName }}
                            </p>
                        </td>
                        <td>{{ vm.UserService.getStatusLabel(item) }}</td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list" pages="2"></pagination>
        </div>
        <div class="modal-footer" >
            <ul class="actions01">
                <li ng-if="vm.userIds.length" class="primary">
                    <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Add' | translate }}</button>
                </li>
                <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                >{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor (lodash, DATATABLES, CLASSIFIER_ENUM, USER_STATUS_ENUM,
                 UserResource, SurveyGroupResource, ListFactory, SiteService, UserService) {
        this.lodash = lodash;
        this.DATATABLES = DATATABLES;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.SurveyGroupResource = SurveyGroupResource;
        this.SiteService = SiteService;
        this.UserService = UserService;
        this.list = ListFactory.createWithPagination(UserResource.query.bind(UserResource));
    }

    $onInit () {
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);
        this.filter = {
            excludedSurveyGroupId: this.surveyGroup.id,
            excludeInActiveUsers: true,
            expand: 'drlsWithValue',
            pageSize: 50
        };
        this.userIds = [];

        if (this.sites.length === 1) {
            this.filter.siteId = this.sites[0].id;
        }
    }

    save () {
        this.SurveyGroupResource.addParticipants({ id: this.surveyGroup.id }, { ids: this.userIds }).$promise
            .then((updatedParticipants) => {
                this.error = false;
                this.uibModalInstance.close(updatedParticipants);
            })
            .catch((response) => {
                this.error = this.lodash.map(response.data, (error) => {
                    return error.message;
                }).join('<br>');
            });
    }

    applyFilter () {
        this.list.fetch(this.filter);
    }

    hasUser (key) {
        return this.lodash.includes(this.userIds, key);
    }

    toggleUser (key) {
        if (this.hasUser(key)) {
            this.lodash.pull(this.userIds, key);
            this.checked = false;
        }
        else {
            this.userIds.push(key);
        }
    }

    toggleAll () {
        this.userIds = this.checked ? this.list.items.map((user) => user.id) : [];
    }

    initBulk () {
        this.userIds = [];
        this.checked = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/survey/participant/index.js